/**
 * Frosted-glass surface toggles — flip here to A/B on device without touching components.
 *
 * Examples:
 *   All off:     { cards: false, header: false, tabBar: false, chats: false, people: false, secondaryButtons: false }
 *   Cards only:  { cards: true, header: false, tabBar: false, chats: false, people: false, secondaryButtons: false }
 *   Chrome only: { cards: false, header: true, tabBar: true, chats: false, people: false, secondaryButtons: false }
 */
export const GLASS_SURFACES = {
  cards: true,
  header: true,
  tabBar: true,
  chats: true,
  people: true,
  secondaryButtons: true,
};

export function getGlassSurfaceRootClasses() {
  const classes = [];
  if (GLASS_SURFACES.cards) classes.push('glass-surface-cards');
  if (GLASS_SURFACES.header) classes.push('glass-surface-header');
  if (GLASS_SURFACES.tabBar) classes.push('glass-surface-tab-bar');
  if (GLASS_SURFACES.chats) classes.push('glass-surface-chats');
  if (GLASS_SURFACES.people) classes.push('glass-surface-people');
  if (GLASS_SURFACES.secondaryButtons) classes.push('glass-surface-secondary-buttons');
  return classes.join(' ');
}

/** Opaque fallbacks when the matching GLASS_SURFACES flag is false. */
export const CARD_SOLID_SURFACE_CLASS =
  'bg-white dark:bg-dark-card border border-gray-200 dark:border-dark-border';

export const HEADER_SOLID_SURFACE_CLASS =
  'bg-white dark:bg-dark-card border-b border-gray-200 dark:border-dark-border shadow-sm';

export const TAB_BAR_SOLID_SURFACE_CLASS =
  'bg-white dark:bg-dark-card border-t border-gray-200 dark:border-dark-border shadow-[0_-4px_12px_rgba(0,0,0,0.06)]';

export const CHAT_LIST_SOLID_SURFACE_CLASS =
  'bg-white dark:bg-dark-card border border-gray-200 dark:border-dark-border shadow-sm';

export const CHAT_CONVERSATION_SOLID_SURFACE_CLASS =
  'bg-white dark:bg-dark-card border border-gray-200 dark:border-dark-border';

export const PEOPLE_LIST_SOLID_SURFACE_CLASS =
  'bg-white dark:bg-dark-card border border-gray-200 dark:border-dark-border';

export const PEOPLE_ROW_SOLID_SURFACE_CLASS =
  'border border-gray-200 dark:border-dark-border bg-white dark:bg-dark-card';

export function chatListSurfaceClass() {
  return `chat-list-surface divide-y divide-gray-200 dark:divide-dark-border rounded-xl overflow-hidden ${
    GLASS_SURFACES.chats ? '' : CHAT_LIST_SOLID_SURFACE_CLASS
  }`;
}

export function chatConversationSurfaceClass(extra = '') {
  return `chat-conversation-surface rounded-none lg:rounded-xl flex flex-col ${extra} ${
    GLASS_SURFACES.chats ? '' : CHAT_CONVERSATION_SOLID_SURFACE_CLASS
  }`.trim();
}

export function peopleListSurfaceClass() {
  return `people-list-surface divide-y divide-gray-100 dark:divide-dark-border/70 rounded-xl px-2 py-1 overflow-hidden ${
    GLASS_SURFACES.people ? '' : PEOPLE_LIST_SOLID_SURFACE_CLASS
  }`;
}

export function peopleEmptySurfaceClass() {
  return `people-list-surface rounded-xl overflow-hidden ${
    GLASS_SURFACES.people ? '' : PEOPLE_LIST_SOLID_SURFACE_CLASS
  }`;
}

export function peopleRowSurfaceClass(extra = '') {
  return `people-row-surface rounded-lg ${extra} ${
    GLASS_SURFACES.people ? '' : PEOPLE_ROW_SOLID_SURFACE_CLASS
  }`.trim();
}

export function groupMembersListSurfaceClass() {
  return `group-members-list-surface divide-y divide-gray-100 dark:divide-dark-border/70 rounded-xl px-2 py-1 overflow-hidden ${
    GLASS_SURFACES.people ? '' : PEOPLE_LIST_SOLID_SURFACE_CLASS
  }`;
}

export const GLASS_POPOVER_MENU_CLASS = 'glass-popover-menu';

export const POPOVER_MENU_SOLID_CLASS =
  'rounded-lg border border-gray-200 bg-white py-1 shadow-lg dark:border-dark-border dark:bg-dark-card';

/** Frosted popover panel — matches modal/header glass tokens */
export function glassPopoverMenuClass(extra = '') {
  return `${GLASS_POPOVER_MENU_CLASS} rounded-lg py-1 shadow-lg ${extra}`.trim();
}
